// Rails
import Rails from "@rails/ujs";
Rails.start();

require("./features/artistList");
require("./features/artistPopup");
require("./features/groups");
require("./features/message");
require("./features/randomPassword");
require("./features/venue");

// Global jQuery
import $ from "jquery";
window.$ = $;
